import { render, staticRenderFns } from "./MedicineGoPricing.vue?vue&type=template&id=2f0b87e2"
import script from "./MedicineGoPricing.vue?vue&type=script&lang=js"
export * from "./MedicineGoPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports